import o, { useState as C, useEffect as m } from "react";
import { Stack as S } from "@mui/material";
import { C as b } from "./chunk.CN4ORC3N.js";
const h = (t) => {
  function s() {
    const e = {};
    return t.chips.forEach((l) => {
      var n;
      typeof t.initialSelection == "string" ? e[l.label] = l.label === t.initialSelection : e[l.label] = !!((n = t.initialSelection) != null && n.includes(l.label));
    }), e;
  }
  const [i, r] = C(
    s()
  ), u = (e, l) => (n) => {
    r((a) => {
      const d = Object.keys(a).filter(
        (c) => a[c]
      ), f = {
        ...a
      };
      return f[e] = !a[e], t.multiSelect || d.forEach((c) => {
        c !== e && (f[c] = !1);
      }), l && l(n), f;
    });
  };
  return m(() => {
    if (t.onChange) {
      const e = Object.keys(i).filter(
        (l) => i[l]
      );
      t.onChange(e);
    }
  }, [i]), /* @__PURE__ */ o.createElement(S, { id: t.id, direction: "row", sx: { flexWrap: "wrap", gap: 2 } }, t.chips.map((e) => /* @__PURE__ */ o.createElement(
    b,
    {
      key: e.id || e.label,
      ...e,
      selected: i[e.label],
      onClick: u(e.label, e.onClick)
    }
  )));
};
export {
  h as C
};
